import { TLanguages } from '@/i18nConfig'
import { useGetV1PortalPublicQuery } from 'core/query/yapi/swap/Collection/query'
import { useParams } from 'next/navigation'

/* 默认永续币对路径 */
const useDefaultCoin = () => {
  const lang = useParams().lang as TLanguages
  const { data: perpetualData } = useGetV1PortalPublicQuery({
    type: 0,
    bizType: 'perpetual',
    lang,
  })
  const perpetualItem = perpetualData?.data?.data?.[0]?.swaps?.[0]
  const perpetualPath = perpetualItem ? perpetualItem?.baseContractCode : ''

  /* 默认交割币对路径 */
  const { data: deliverData } = useGetV1PortalPublicQuery({
    type: 0,
    bizType: 'deliver',
    lang,
  })
  const deliverItem = deliverData?.data?.data?.[0]?.swaps?.[0]
  const deliverPath = deliverItem ? `${deliverItem?.baseContractCode}_${deliverItem?.contractType}_d` : ''
  return {
    perpetualPath,
    deliverPath,
  }
}

export default useDefaultCoin
